var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:course"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.51398 2C5.20998 2.129 4.33198 2.419 3.67598 3.076C2.50098 4.253 2.50098 6.148 2.50098 9.939V13.959C2.50098 17.749 2.50098 19.645 3.67598 20.823C4.85098 22.001 6.74298 22 10.526 22H12.533C16.316 22 18.208 22 19.383 20.823C20.45 19.753 20.549 18.106 20.558 14.977",
    stroke: "#BEBEBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5257 7.00004L11.5287 10.5C12.0887 11.61 12.7917 11.9 14.5387 12C15.9277 11.966 16.7337 11.802 17.4217 11.204C17.8907 10.796 18.1027 10.181 18.2057 9.56904L18.5497 7.50004M21.0577 5.50004V10.5M8.60071 4.93304C10.1877 3.61604 11.6017 2.90904 14.5347 2.13104C14.8656 2.04368 15.2137 2.04541 15.5437 2.13604C18.1397 2.85004 19.5417 3.48404 21.4197 4.89404C21.4997 4.95404 21.5237 5.06604 21.4677 5.14904C20.8547 6.05104 19.4857 6.78204 16.1277 8.08404C15.4283 8.35317 14.6531 8.34889 13.9567 8.07204C10.3807 6.65204 8.73671 5.89204 8.53671 5.10304C8.53021 5.07156 8.53278 5.03887 8.5441 5.00878C8.55543 4.97869 8.57506 4.95243 8.60071 4.93304Z",
    stroke: "#BEBEBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessments);
export default __webpack_public_path__ + "static/media/assessments.28b0332681aca46664bd8b041511b375.svg";
export { ForwardRef as ReactComponent };